import type * as marked from 'marked';

export function processAllTokens(tokens: marked.Token[]) {
    const result: marked.Token[] = [];

    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i]!;
        const hasTokenRawValue = token.raw && token.raw.length > 1;
        const isNotLastToken = i !== tokens.length - 1;

        result.push(token);

        if (hasTokenRawValue && isNotLastToken) {
            const prevToken = tokens[i - 1];
            const isSpace = token.type === 'space';
            const doubleLineBreak = isSpace && prevToken &&
                (prevToken.type === 'blockquote' || prevToken.type === 'list');
            const raw = isSpace ? token.raw.replace(/ |\t/g, '') : token.raw;

            let lastCharAt = doubleLineBreak ? raw.length - 3 : raw.length - 2;

            while (raw[lastCharAt] === '\n') {
                result.push({
                    type: 'extended_br',
                    text: '\n',
                    raw: '\n',
                    tokens: [],
                });

                lastCharAt--;
            }
        }
    }

    /*
     * COMMENT: Если массив токенов - является односвязным списком,
     * тогда последний его элемент будет помечен флагом isSingle
    */
    markSingleIfNeeded(result);
    return result;
}

function markSingleIfNeeded(tokens: marked.Tokens.Generic[]) {
    let tokensToCheck = tokens;
    while (tokensToCheck.length === 1) {
        if (!tokensToCheck[0]?.tokens) {
            break;
        }

        tokensToCheck = tokensToCheck[0]!.tokens;
    }

    if (tokensToCheck.length === 1) {
        tokensToCheck[0]!.isSingle = true;
    }
}
